import React from "react";

// Communication's tabs (Fax / Messaging / ...). Compact and calm (owner 10-13,
// OSA staff: "everything moved up"): 32 px high, one accent (navy) for the
// selected tab as a tint + border, never a filled saturated pill.
const TabComponent = ({ tabs, selectedTab, onSelectTab }) => {
  return (
    <div className="flex h-8 items-center gap-1" role="tablist" aria-label="Communication">
      {tabs.map((tab, index) => {
        // A tab may carry a fixed id (fax.jsx skips tabs per practice);
        // without one its position is its id.
        const id = tab.id ?? index;
        const on = selectedTab === id;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onSelectTab(id)}
            className={`flex h-8 items-center whitespace-nowrap rounded-md border px-3 font-inter text-[14px] ${
              on
                ? "border-[#1D2951]/30 bg-[#1D2951]/[0.07] font-semibold text-[#1D2951]"
                : "border-transparent font-normal text-[#475467] hover:bg-[#F2F4F7]"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TabComponent;
